// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__3GsSi","btn":"BlogCard_btn__1Z6ta","extra":"BlogCard_extra__2gqel"};